// extracted by mini-css-extract-plugin
module.exports = {"header":"_2nxXiD20","header-content":"_3TRHw5oq","logo":"_1Zu3CHPj","logo-wrapper":"_3muiR_kx"};